// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2":"css/homepage","33":"css/styles"}[chunkId] + ".css";
};